(function () {
  if (window.cohinaHelpCenterLoaded) return;
  window.cohinaHelpCenterLoaded = true;

  const SELECTORS = {
    category: '[data-help-category]',
    faq: '[data-help-faq]',
    faqToggle: '[data-help-faq-toggle]',
    searchInput: '[data-help-search-input]',
    nav: '[data-help-nav]',
    notFound: '[data-help-not-found]',
  };

  const CLASSES = {
    open: 'is-open',
    hidden: 'is-hidden',
    show: 'is-show',
  };

  const cleanups = new WeakMap();

  function normalizeText(value) {
    return (value || '').normalize('NFKC').toLowerCase().trim();
  }

  function setFaqOpen(faq, isOpen) {
    faq.classList.toggle(CLASSES.open, isOpen);
    const toggle = faq.querySelector(SELECTORS.faqToggle);
    if (toggle) toggle.setAttribute('aria-expanded', String(isOpen));
  }

  function initHelpAccordion(category) {
    const onClick = (event) => {
      const toggle = event.target.closest(SELECTORS.faqToggle);
      if (!toggle || !category.contains(toggle)) return;
      const faq = toggle.closest(SELECTORS.faq);
      if (!faq) return;
      setFaqOpen(faq, !faq.classList.contains(CLASSES.open));
    };

    // aria-expanded は Liquid では出力しない（JS 無効時は CSS で全開になるため）
    category.querySelectorAll(SELECTORS.faq).forEach((faq) => {
      setFaqOpen(faq, faq.classList.contains(CLASSES.open));
    });

    category.addEventListener('click', onClick);

    return () => {
      category.removeEventListener('click', onClick);
      category.querySelectorAll(SELECTORS.faqToggle).forEach((toggle) => {
        toggle.removeAttribute('aria-expanded');
      });
    };
  }

  function renderHelpCategoryNav(nav) {
    const links = [];
    document.querySelectorAll(SELECTORS.category).forEach((category) => {
      const title = category.dataset.helpCategoryTitle;
      const anchor = category.dataset.helpCategoryAnchor;
      if (!title || !anchor) return;
      const link = document.createElement('a');
      link.className = 'help-nav__link';
      link.href = '#' + anchor;
      link.textContent = title;
      links.push(link);
    });
    nav.replaceChildren(...links);
  }

  function initHelpCategoryNav(nav) {
    renderHelpCategoryNav(nav);

    return () => {
      nav.replaceChildren();
    };
  }

  function applyHelpSearch(rawKeyword) {
    const keyword = normalizeText(rawKeyword);
    const isFiltering = keyword !== '';
    let totalMatches = 0;

    document.querySelectorAll(SELECTORS.category).forEach((category) => {
      let categoryMatches = 0;
      category.querySelectorAll(SELECTORS.faq).forEach((faq) => {
        const isMatch = !isFiltering || normalizeText(faq.textContent).includes(keyword);
        faq.classList.toggle(CLASSES.hidden, !isMatch);
        if (isMatch) categoryMatches += 1;
      });
      category.classList.toggle(CLASSES.hidden, isFiltering && categoryMatches === 0);
      totalMatches += categoryMatches;
    });

    document.querySelectorAll(SELECTORS.notFound).forEach((notFound) => {
      notFound.classList.toggle(CLASSES.show, isFiltering && totalMatches === 0);
    });
  }

  function initHelpSearch(input) {
    const onInput = () => applyHelpSearch(input.value);

    input.addEventListener('input', onInput);
    applyHelpSearch(input.value);

    return () => {
      input.removeEventListener('input', onInput);
      applyHelpSearch('');
    };
  }

  function mount(element, init) {
    if (cleanups.has(element)) return;
    cleanups.set(element, init(element));
  }

  function unmount(element) {
    const cleanup = cleanups.get(element);
    if (!cleanup) return;
    cleanup();
    cleanups.delete(element);
  }

  function mountWithin(root) {
    root.querySelectorAll(SELECTORS.category).forEach((element) => mount(element, initHelpAccordion));
    root.querySelectorAll(SELECTORS.nav).forEach((element) => mount(element, initHelpCategoryNav));
    root.querySelectorAll(SELECTORS.searchInput).forEach((element) => mount(element, initHelpSearch));
  }

  function unmountWithin(root) {
    const selector = [SELECTORS.category, SELECTORS.nav, SELECTORS.searchInput].join(',');
    root.querySelectorAll(selector).forEach(unmount);
  }

  function refreshShared() {
    document.querySelectorAll(SELECTORS.nav).forEach(renderHelpCategoryNav);
    const input = document.querySelector(SELECTORS.searchInput);
    applyHelpSearch(input ? input.value : '');
  }

  function scrollToHashCategory() {
    const hash = window.location.hash.slice(1);
    if (!hash) return;
    let anchor;
    try {
      anchor = decodeURIComponent(hash);
    } catch (error) {
      anchor = hash;
    }
    const target = Array.from(document.querySelectorAll(SELECTORS.category)).find(
      (category) => category.id === anchor
    );
    if (target) target.scrollIntoView();
  }

  function initHelpCenter() {
    mountWithin(document);
    scrollToHashCategory();

    const isDesignMode = Boolean(window.Shopify && window.Shopify.designMode);
    if (!isDesignMode) {
      return () => unmountWithin(document);
    }

    const onSectionLoad = (event) => {
      mountWithin(event.target);
      refreshShared();
    };
    const onSectionUnload = (event) => {
      unmountWithin(event.target);
      window.setTimeout(refreshShared, 0);
    };
    const onSectionReorder = () => refreshShared();
    const onBlockSelect = (event) => {
      const faq = event.target.closest(SELECTORS.faq);
      if (!faq) return;
      // 検索の絞り込みで隠れていても、エディタで選択したブロックは必ず見える状態にする
      faq.classList.remove(CLASSES.hidden);
      const category = faq.closest(SELECTORS.category);
      if (category) category.classList.remove(CLASSES.hidden);
      setFaqOpen(faq, true);
    };

    document.addEventListener('shopify:section:load', onSectionLoad);
    document.addEventListener('shopify:section:unload', onSectionUnload);
    document.addEventListener('shopify:section:reorder', onSectionReorder);
    document.addEventListener('shopify:block:select', onBlockSelect);

    return () => {
      document.removeEventListener('shopify:section:load', onSectionLoad);
      document.removeEventListener('shopify:section:unload', onSectionUnload);
      document.removeEventListener('shopify:section:reorder', onSectionReorder);
      document.removeEventListener('shopify:block:select', onBlockSelect);
      unmountWithin(document);
    };
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initHelpCenter, { once: true });
  } else {
    initHelpCenter();
  }
})();
